import { getMakeupHairApiBaseUrl } from '../../makeuphair/utils/apiConfig';
import { kioskAuthHeaders } from '../../makeuphair/utils/kioskAuthHeaders';
import { getFranchiseOrganizationId } from '../../shared/franchiseFlowAuth';

function base() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/hair-flux-prompt`;
}

function withOrg(path) {
  const orgId = getFranchiseOrganizationId();
  if (!orgId) return path;
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}organization_id=${encodeURIComponent(String(orgId))}`;
}

export async function fetchHairFluxPromptBuildInfo() {
  const res = await fetch(`${base()}/build-info`, { credentials: 'include' });
  return res.json();
}

export async function generateHairFluxPrompt({ image, prompt, wrapIdentity = true }) {
  const res = await fetch(`${base()}${withOrg('/generate')}`, {
    method: 'POST',
    credentials: 'include',
    headers: kioskAuthHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      image,
      prompt,
      wrap_identity: wrapIdentity,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || data?.code || `Request failed (${res.status})`);
    err.code = data?.code;
    err.status = res.status;
    throw err;
  }
  return data;
}
